import { gtmSendEvent } from "@wojo/analytics";
import { useI18n } from "@wojo/localization";
import { Button, Markdown, Modal, ModalBody, Text } from "@wojo/ui";
import { useState } from "react";
import { useTourPageContext } from "../../../_client/context";
import { useTripBuilder } from "../context/TripBuilderContext";
import styles from "./TripBuilderQuoteStep.module.scss";

export const QuoteFootnotes: React.FC = () => {
    const { contactConfig, pageConfig } = useTourPageContext();
    const { gcDeparture } = useTripBuilder();
    const { productPage } = useI18n("productPage");
    const [isModalOpen, setIsModalOpen] = useState(false);

    if (!!gcDeparture && contactConfig?.phoneNumberFormatted) {
        return (
            <Markdown
                className={styles.footnotes}
                markdown={productPage.tripBuilder.quote.footnote.l({
                    phone: `[${contactConfig.phoneNumberFormatted}](tel:${contactConfig.phoneNumber})`,
                })}
                onClickCapture={(e) => {
                    if (e.target instanceof HTMLAnchorElement) {
                        if (e.target.href.startsWith("tel:")) {
                            gtmSendEvent({
                                event: "track",
                                ga4Tracking: {
                                    ga4_object: "TRIP_BUILDER",
                                    ga4_action: "PHONE_CALL",
                                    phoneNumber:
                                        contactConfig.phoneNumberFormatted ||
                                        "",
                                },
                            });
                        } else {
                            gtmSendEvent({
                                event: "track",
                                ga4Tracking: {
                                    ga4_object: "TRIP_BUILDER",
                                    ga4_action: "LINK_CLICKED",
                                    clickText: e.target.textContent || "",
                                    destinationUrl: e.target.href,
                                },
                            });
                        }
                    }
                }}
            />
        );
    }

    if (!pageConfig.cancellationMessaging) {
        return null;
    }

    return (
        <>
            <Text.Body tag="div" className={styles.footnotes}>
                <Markdown
                    className={styles["footnotes-markdown"]}
                    markdown={pageConfig.cancellationMessaging}
                />
                {pageConfig.cancellationMessageModalContent && (
                    <Button
                        variant="quiet"
                        type="button"
                        onClick={() => {
                            gtmSendEvent({
                                event: "track",
                                ga4Tracking: {
                                    ga4_object: "TRIP_BUILDER",
                                    ga4_action: "MODAL_OPENED",
                                    modalId: "Tour Finalization Date",
                                },
                            });
                            setIsModalOpen(true);
                        }}
                    >
                        {productPage.tripBuilder.quote.cancellation.cta.l()}
                    </Button>
                )}
            </Text.Body>
            {pageConfig.cancellationMessageModalContent && (
                <Modal
                    isOpen={isModalOpen}
                    accessibleTitle={productPage.tripBuilder.quote.cancellation.modal.title.l()}
                    onCloseRequested={() => {
                        gtmSendEvent({
                            event: "track",
                            ga4Tracking: {
                                ga4_object: "TRIP_BUILDER",
                                ga4_action: "MODAL_CLOSED",
                                modalId: "Tour Finalization Date",
                            },
                        });
                        setIsModalOpen(false);
                    }}
                >
                    <ModalBody>
                        <Text.Heading
                            order="2"
                            style={{ marginBottom: "var(--g-spacing-md)" }}
                        >
                            {productPage.tripBuilder.quote.cancellation.modal.title.l()}
                        </Text.Heading>
                        <Markdown
                            className={styles["footnotes-markdown"]}
                            markdown={
                                pageConfig.cancellationMessageModalContent
                            }
                            onClickCapture={(e) => {
                                if (e.target instanceof HTMLAnchorElement) {
                                    gtmSendEvent({
                                        event: "track",
                                        ga4Tracking: {
                                            ga4_object: "TRIP_BUILDER",
                                            ga4_action: "LINK_CLICKED",
                                            clickText:
                                                e.target.textContent || "",
                                            destinationUrl: e.target.href,
                                        },
                                    });
                                }
                            }}
                        />
                    </ModalBody>
                </Modal>
            )}
        </>
    );
};
